import { createActionHandler, createReducer } from '@pressreader/appstore';
import { TargetPlatform } from '@pressreader/types';

import { Platform, WebSDKMode } from '../types';

import { appStarted, coreModuleLoadDone, legacyPlatformChanged, setOnlineStatus, updateCoreModuleStateAction } from './actions';

interface State {
    targetPlatform: TargetPlatform;
    faceliftEnabled: boolean;
    legacyPlatform: Platform;
    appStarted: boolean;
    isOnline: boolean;
    isWebSDK: boolean;
    webSDKMode: WebSDKMode;
}

const initialState: State = {
    targetPlatform: TargetPlatform.Web,

    /** Whether Facelift UI is enabled. */
    faceliftEnabled: false,

    legacyPlatform: Platform.Web,

    appStarted: false,

    isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,

    // Seeded from a window flag (set by apps/websdk/src/init.globals.ts) so
    // selectors return the right value before any saga runs. The store is
    // created synchronously when @pressreader/appstore is imported, and the
    // websdk's init.globals.ts (which has no imports of its own) runs ahead
    // of that import chain, so the flag is in place before this initialState
    // is evaluated.
    isWebSDK: typeof window !== 'undefined' && (window as Window & { isWebSDK?: boolean }).isWebSDK === true,

    // Window-flag seeding like isWebSDK above; set by init.mode.{reader,article}.ts. Default 'full'.
    webSDKMode: (typeof window !== 'undefined' && (window as Window & { webSDKMode?: WebSDKMode }).webSDKMode) || 'full',
};

const reducer = createReducer(
    initialState,
    createActionHandler(coreModuleLoadDone, (state, action) => ({
        ...state,
        targetPlatform: action.payload.targetPlatform,
        faceliftEnabled: action.payload.faceliftEnabled,
        isWebSDK: action.payload.isWebSDK ?? state.isWebSDK,
    })),
    createActionHandler(appStarted, (state, _) => ({
        ...state,
        appStarted: true,
    })),
    createActionHandler(legacyPlatformChanged, (state, { payload }) => ({
        ...state,
        legacyPlatform: payload.platform,
    })),
    createActionHandler(updateCoreModuleStateAction, (state, action) => ({
        ...state,
        ...action.payload,
    })),
    createActionHandler(setOnlineStatus, (state, action) => ({
        ...state,
        isOnline: action.payload.isOnline,
    })),
);

export { reducer, type State };
